<div class="row div-spacer">
    <div class="col-sm-4 text-center">
        <div class="row-pitch-inner">
            <i class="fa fa-paint-brush fa-4x text-success"></i>
            <br />
            Simple & easy to use for parents, teachers and students
        </div>
    </div>
    <div class="col-sm-4 text-center">
        <div class="row-pitch-inner">
            <i class="fa fa-empire fa-4x text-success"></i>
            <br />
            Powerful features for student learning and monitoring
        </div>
    </div>
    <div class="col-sm-4 text-center">
        <div class="row-pitch-inner">
            <i class="fa fa-binoculars fa-4x text-success"></i>
            <br />
            Unlimited Questions and Answers
        </div>
    </div>
</div>
